let menuWrapper = document.querySelector('.js-menu-wrapper');
let menuHandler = document.querySelector('.js-menu-handler');
let announcementBar = document.querySelector('.announcement-bar');

if(!announcementBar){
  menuWrapper.style.top = '80px';
}

menuHandler.addEventListener('click', function() {
  menuWrapper.classList.toggle('show');

  if (menuWrapper.classList.contains('show')) {
    menuHandler.setAttribute('aria-expanded', 'true');
    menuWrapper.setAttribute('aria-hidden', 'false');
  } else {
    menuHandler.setAttribute('aria-expanded', 'false');
    menuWrapper.setAttribute('aria-hidden', 'true');
  }
});

// Press Esc to close the menu
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    menuWrapper.classList.remove('show');
    menuHandler.setAttribute('aria-expanded', 'false');
    menuWrapper.setAttribute('aria-hidden', 'true');
  }
});
